import { DataPropConfig } from 'dg-input-lib';

export enum SurveyQuestionType {
  TEXTBOX = 19055,
  RADIO = 19056,
  CHECKBOX = 19057,
  COMBOBOX = 24001,
  DATEBOX = 24003,
  TIMEBOX = 24004,
  LISTBOX = 24002,
  PASSWORD = 24005,
  EMAIL = 24006,
  NUMBER = 24007,
  TEXT = 24008,
  FILE = 24009,
  DATE_RANGE_BOX = 24010,
  TIME_RANGE_BOX = 24011,
}

export const QUESTION_CONFIG_PROP: DataPropConfig = {
  idProp: 'questionId',
  comboProp: 'optionMapRestructured',
  nameProp: 'questionDesc',
  placeholderProp: 'placeHolder',
  requiredProp: 'answerCompulsary',
  disabledProp: 'disabled',
  typeProp: 'questionTypeForDgDynamicInput',
  classProp: 'className',
  styleProp: 'style',
  validationsProp: 'validations',
  hintProp: 'hint',
  prefixProp: 'prefix',
  suffixProp: 'suffix',
  pipeProp: 'pipe',
};
